import { useContext, useState ,useRef, useEffect } from "react"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { Button, CustomContainer, FlexRow, Form, GridContainer, PinLabelD3, ScreenTitle } from "src/style"
import { AppCenterPopupD3, CenterPopupHeaderD3 } from "src/component"
import PinIcon from 'src/assets/svg/tx-pin-icon-d3'
import { handleTypeNumberControl } from "src/utils/utility"

export const NewPinD3: React.FC<any> = ({next, shouldConfirm, title, confirmTitle, close}) => {
    const {notifier} = useContext(VisibilityContext)
    const [pin, setPin] = useState('')

    const newPinRef = useRef<any>(null)
    const confirmPinRef = useRef<any>(null)

    useEffect(() => {
        newPinRef.current = ''
        confirmPinRef.current = ''
    }, [])

    const handlePin = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length < 5) {
            setPin(e.target.value)
        }
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (pin.length != 4) return notifier.show('Kindly provide a valid PIN', 'Validation Response')
        if (!newPinRef.current && shouldConfirm) {
            newPinRef.current = pin
            setPin('')
            return false
        }
        else if (shouldConfirm) {
            confirmPinRef.current = pin

            if (newPinRef.current != confirmPinRef.current) return notifier.show('PINs do not match', 'Validation Response')
        }
        else newPinRef.current = pin
        
        if (next) next(pin)
    }


    return (
        <AppCenterPopupD3 height='42' zIndex='6' overflow='hidden' close={close}>
            <CenterPopupHeaderD3 title='' close={close} />
            <CustomContainer 
                height="42"
                style={{maxHeight: '85%'}}
                className="popup-content-container"
            >
                <GridContainer >
                    <PinIcon className='icon-component' />
                    <ScreenTitle textSize="2.2" fontWeight="700" topMargin='2.5'>
                        {!newPinRef.current ? title || 'Enter New PIN' : confirmTitle || 'Confirm New PIN'}
                    </ScreenTitle>
                    <Form onSubmit={handleProceed} topMargin='2.5'>
                        <GridContainer>
                            <FlexRow 
                                width="auto" sizeUnit="" gap='1.4'
                            >
                                <input 
                                    className='display-hidden' id='pin' 
                                    name="pin" value={pin} type='number'
                                    onChange={handlePin}
                                    onKeyDown={handleTypeNumberControl}
                                    onKeyUp={handleTypeNumberControl} 
                                    autoFocus={true} autoComplete="off"
                                />
                                <PinLabelD3 style={{paddingTop: '1rem'}} className={`${pin.length === 0 ? 'active-pin-box' : ''}`} htmlFor='pin' >{pin[0] ? '*' : ''}</PinLabelD3>
                                <PinLabelD3 style={{paddingTop: '1rem'}} className={`${pin.length === 1 ? 'active-pin-box' : ''}`} htmlFor='pin' >{pin[1] ? '*' : ''}</PinLabelD3>
                                <PinLabelD3 style={{paddingTop: '1rem'}} className={`${pin.length === 2 ? 'active-pin-box' : ''}`} htmlFor='pin' >{pin[2] ? '*' : ''}</PinLabelD3>
                                <PinLabelD3 style={{paddingTop: '1rem'}} className={`${pin.length >= 3 ? 'active-pin-box' : ''}`} htmlFor='pin' >{pin[3] ? '*' : ''}</PinLabelD3>
                            </FlexRow>
                        </GridContainer>
                        <Button 
                            width='100' sizeUnit="%" height='4.4' topMargin='4' 
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F' titleSize='1.4'
                        >
                            {!newPinRef.current ? 'Confirm' : 'Proceed'}
                        </Button>
                    </Form>
                </GridContainer>
            </CustomContainer>
        </AppCenterPopupD3 >
    )
}